import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { editContent } from "../../modules/editor";


import FieldSection from './FieldSection';

const headerTypeSet: any = {
	none: [['image']],
	left: [['text'],['image']],
	right: [['image'],['text']],
}

type Props = {
	selectedContentId: number;
	currentContent: any;
}

function SelectedContentHeader({ selectedContentId, currentContent }: Props) {
	const [headerType, setHeaderType] = useState('none');

	const dispatch = useDispatch();

	const styleTarget = `${selectedContentId}/style/0`;

	useEffect(() => {
		setHeaderType(currentContent?.content?.style[0]?.box?.headerType);
	}, [currentContent]);

	const onChangeLayout = (e: any) => {
		const { value } = e.target;
		dispatch(editContent({ target: `${selectedContentId}/column`, data: headerTypeSet[value] }));
		dispatch(editContent({ target: `${styleTarget}/box/headerType`, data: value }));
	}	

	return (
		<div className="editor-sidebar-selected-content-setting">
			<h3 className="field-section-title">텍스트 표시</h3>
			<FieldSection
				labelName=""
				label={false}
				fullWidth={true}
			>
				<select
					className="select full"
					value={headerType}
					onChange={onChangeLayout}
				>
					<option value="none">없음</option>
					<option value="left">왼쪽</option>
					<option value="right">오른쪽</option>
				</select>
			</FieldSection>
		</div>
	);
}

export default SelectedContentHeader;